import validationMessages from "vee-validate/dist/locale/fr";

const yesNoOptions = [
    {value: "Yes", text: "Oui"},
    {value: "No", text: "Non"}
]

export default {
    privacyLinkLabel: "politique de confidentialité",
    privacyLink: '/fr-fr/about/legal/privacy/',
    privacyText: "Citrix traitera vos données uniquement dans le respect de notre",
    resetText: "Si le formulaire prérempli n’est pas le vôtre, veuillez",
    resetText2: "pour le réinitialiser.",
    resetLinkText: "cliquer ici",
    yes: "Oui",
    no: "Non",
    submitBtn: {
        "Submit" : "Envoyer",
        "Get the eBook" : "Téléchargez l’e-Book",
        "Watch demo" : "Regardez la démo",
        "Get the kit" : "Obtenir le kit",
        "Compare now" : "Comparer maintenant",
        "Request a demo": "Demander une démo",
        "Request a call": "Demander à être contacté"
    },
    apjPrivacy:{
        title: "Comment nous utilisons vos informations personnelles",
        company: "Citrix Systems Japan K.K.",
        part1: "(<< Citrix >>) utilisera et stockera vos informations personnelles conformément à la législation et à la réglementation applicable en matière de protection des données et à la",
        linkText: "Politique de confidentialité de Citrix,",
        part2: "et dans des circonstances où l’accès est strictement limité. Citrix utilisera vos informations personnelles uniquement tel que stipulé dans sa Politique de confidentialité et à aucune autre fin. En vertu de sa Politique de confidentialité, Citrix pourra confier le traitement des informations personnelles à des entreprises nationales ou étrangères, partager des informations personnelles avec d’autres bureaux ou filiales de Citrix dans le monde entier, ou envoyer des informations personnelles à des tiers établis dans le pays ou à l’étranger. Lorsque vous envoyez des informations personnelles à Citrix, vous acceptez que ces informations personnelles soient collectées et traitées tel que décrit dans la Politique de confidentialité de Citrix.",
        privacyAccept: "J’ai lu et j’accepte la Politique de confidentialité de Citrix"
    },
    fields: {
        "AnnualSales": {
            label: "Annual Sales"
        },
        "Company_Self_Reported__c": {
            label: "Entreprise"
        },
        "department": {
            label: "Département",
            options: [
                { value: "Application Management", text: "Gestion des applications" },
                { value: "Consulting Services", text: "Services de consulting" },
                { value: "Education / Training", text: "Enseignement / Formation" },
                { value: "Engineering", text: "Ingénierie" },
                { value: "Executive Office / Administration", text: "Direction / Administration" },
                { value: "Finance / Accounting", text: "Finance / Comptabilité" },
                { value: "Human Resources", text: "Ressources humaines" },
                { value: "Information Technology - Systems", text: "Technologie-Systèmes d'information" },
                { value: "Legal", text: "Juridique" },
                { value: "Marketing / PR", text: "Marketing / Relations publiques" },
                { value: "Networking", text: "Réseaux" },
                { value: "Operations / Manufacturing", text: "Opérationnel / Fabrication" },
                { value: "Pre-Sales / Technical Support", text: "Force de vente / Support technique" },
                { value: "Project Management", text: "Gestion de projets" },
                { value: "Purchasing", text: "Achats" },
                { value: "Sales / Bus-Corp Development", text: "Développement des ventes / commercial-de l'entreprise" },
                { value: "Security", text: "Sécurité" },
                { value: "Web / Online / E-Business", text: "Web / En ligne / E-business" }
            ]
        },
        "Industry_Self_Reported__c": {
            label: "Secteur",
            options: [
                { value: "Agriculture", text: "Agriculture" },
                { value: "Art & Membership", text: "Art et associations" },
                { value: "Insurance", text: "Assurances" },
                { value: "Charitable/Non-Profit", text: "Caritatif/Non lucratif" },
                { value: "Conglomerate", text: "Conglomérat" },
                { value: "Business Consulting", text: "Conseil aux entreprises" },
                { value: "Construction and Design", text: "Construction et design" },
                { value: "Entertainment", text: "Divertissement" },
                { value: "E-Commerce", text: "E-commerce" },
                { value: "Publishing/Printing", text: "Edition/Impression" },
                { value: "Education", text: "Enseignement" },
                { value: "Finance", text: "Finance" },
                { value: "Service Provider", text: "Fournisseur de services" },
                { value: "Government/State-Province", text: "Gouvernement/Administration d'Etat-de province" },
                { value: "Government/Local", text: "Gouvernement/Administrations locales" },
                { value: "Government/National-Federal", text: "Gouvernement/Administrations nationales-fédérales" },
                { value: "Hospitality", text: "Hôtellerie" },
                { value: "Real Estate", text: "Immobilier" },
                { value: "Manufacturing", text: "Industrie" },
                { value: "Chemical Manufacturing", text: "Industrie chimique" },
                { value: "Mining - All", text: "Industrie minière - Tous" },
                { value: "Oil and Gas", text: "Industrie pétrolière et gazière" },
                { value: "Pharmaceuticals", text: "Industrie pharmaceutique" },
                { value: "Engineering", text: "Ingénierie" },
                { value: "Legal", text: "Juridique" },
                { value: "Consumer Packaged Goods", text: "Produits de consommation emballés" },
                { value: "Health Care", text: "Santé" },
                { value: "Professional Services", text: "Services aux entreprises" },
                { value: "Business/Personal Services", text: "Services aux entreprises/particuliers" },
                { value: "Household Services", text: "Services aux ménages" },
                { value: "Personnel Services", text: "Services de personnel" },
                { value: "Utilities", text: "Services publics" },
                { value: "Technology", text: "Technologie" },
                { value: "Telecommunication", text: "Télécommunications" },
                { value: "Transportation", text: "Transport" },
                { value: "Retail/Wholesale", text: "Vente au détail/en gros" }
            ]
        },
        "NumberOfEmployees_Self_Reported__c" : {
            label: "Taille de l’entreprise",
            options: [
                { value: "50", text: "1-50" },
                { value: "500", text: "51-500" },
                { value: "749", text: "501-749" },
                { value: "4999", text: "750-4,999" },
                { value: "19999", text: "5,000-19,999" },
                { value: "20000", text: "20,000+" }
            ]
        },
        "NumberofEmployees__here___atlocation": {
            label: "Taille de l’entreprise",
            options: [
                { value: "5,001 +", text: "+ 5 001" },
                { value: "1,001 to 5,000", text: "de 1 001 à 5 000" },
                { value: "501 to 1,000", text: "de 501 à 1 000" },
                { value: "251 to 500", text: "de 251 à 500" },
                { value: "1 to 250", text: "1 à 250" }
            ]
        },
        "Address2": {
            label: "Ligne d'adresse 2"
        },
        "Address3": {
            label: "Ligne d'adresse 3"
        },
        "city": {
            label: "Ville"
        },
        "country": {
            label: "Pays"
        },
        "email": {
            label: "E-mail professionnel"
        },
        "firstName": {
            label: "Prénom"
        },
        "lastName": {
            label: "Nom"
        },
        "phone": {
            label: "Numéro de téléphone"
        },
        "mobilePhone": {
            label: "Mobile Phone"
        },
        "postalCode": {
            label: "Code postal"
        },
        "salutation": {
            label: "Civilité",
            options: [
                { value: "Dr.", text: "Dr."},
                { value: "Egr. Sig.", text: "Egr. Sig."},
                { value: "Frau", text: "Frau"},
                { value: "Gent.ma Sig.ra", text: "Gent.ma Sig.ra"},
                { value: "Herr", text: "Herr"},
                { value: "Madame", text: "Madame"},
                { value: "Mademoiselle", text: "Mademoiselle"},
                { value: "Miss", text: "Miss"},
                { value: "Monsieur", text: "Monsieur"},
                { value: "Mr.", text: "Mr."},
                { value: "Mrs.", text: "Mrs."},
                { value: "Ms.", text: "Ms."},
                { value: "Professor", text: "Professor"},
                { value: "Señor", text: "Señor"},
                { value: "Señora", text: "Señora"}
            ]
        },
        "state": {
            label: "Etat/Province"
        },
        "address": {
            label: "Adresse"
        },
        "Job_Title__c": {
            label: "Intitulé de poste",
            options: [
                { value: "Network Administrator / Engineer", text: "Administrateur / Ingénieur réseau" },
                { value: "System Administrator", text: "Administrateur système" },
                { value: "Analyst", text: "Analyste" },
                { value: "Architect", text: "Architecte" },
                { value: "Assistant", text: "Assistant" },
                { value: "Business Manager", text: "Business Manager" },
                { value: "C-Level / President / VP", text: "Comité de direction / Président / Vice-président" },
                { value: "Consultant", text: "Consultant" },
                { value: "Developer / Programmer", text: "Développeur / Programmeur" },
                { value: "Director", text: "Directeur" },
                { value: "IT Manager", text: "Directeur informatique" },
                { value: "Student", text: "Etudiant" },
                { value: "Owner / Partner", text: "Propriétaire / Partenaire" }
            ]
        },
        "Project_Budget__c": {
            label: "Budget pour le projet",
            options: [
                { value: "Yes", text: "Oui" },
                { value: "No", text: "Non" },
                { value: "Unknown", text: "Inconnu" }
            ]
        },
        "Primary_Product_Interest__c": {
            label: "CTRL pour sélectionner plus d'un choix (max 5 choix)"
        },
        "Purchase_Timeframe__c": {
            label: "Délai d’achat",
            options: [
                { value: "3 months or less", text: "3 mois ou moins" },
                { value: "4 to 6 months", text: "4 à 6 mois" },
                { value: "7 months or more", text: "7 mois ou plus" },
                { value: "No time frame", text: "Pas de délai" },
                { value: "Unknown", text: "Incertain" }
            ]
        },
        "Email_Blast_OK__c": {
            label: "Pouvons-nous vous envoyer des e-mails ?",
            options: [
                { value: "Yes", text: "Oui" },
                { value: "No", text: "Non" }
            ]
        },
        "Direct_Mail_OK__c": {
            label: "May we contact you by mail?",
            options: [
                { value: "Yes", text: "Oui" },
                { value: "No", text: "Non" }
            ]
        },
        "OK_to_Call__c": {
            label: "Pouvons-nous vous joindre par téléphone ?",
            options: [
                { value: "Yes", text: "Oui" },
                { value: "No", text: "Non" }
            ]
        },
        "Preferred_Language__c": {
            label: "Preffered language"
        },
        "Sales_Contact_Requested__c": {
            label: "Je souhaite être contacté par un commercial"
        },
        //PrefCenter fields/options
        "Unsubscribed": {
            label: "Me désabonner de toutes les communications marketing par e-mail.",
            options: [...yesNoOptions]
        },
        "Marketing_Suspended_30_Days__c": {
            label: "Suspendre les communications pendant 30 jours.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_Workspace__c": {
            label: "Dans quelle mesure les espaces de travail digitaux (applications, postes de travail, fichiers et appareils mobiles) vous aident à mieux travailler, où que vous soyez.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_VirtualAppsDesktops__c": {
            label: "Comment accéder de façon sécurisée à l’ensemble des applications, postes de travail et données sur tous types d’appareils.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_NetworkingADC__c": {
            label: "Comment gérer la mise à disposition d’applications monolithiques et de microservices dans un environnement multi-cloud hybride.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_SDWan__c": {
            label: "Comment offrir à vos utilisateurs le réseau haute performance Always-on dont ils ont besoin.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_Analytics__c": {
            label: "Comment détecter les menaces de sécurité et les problèmes de performance grâce à l’analytique et aux insights, afin de les stopper avant qu’ils ne se concrétisent.",
            options: [...yesNoOptions]
        }
    },
    preferenceCenter: {
        formTitle: "Centre de gestion des préférences de contact par e-mail Citrix",
        thankyou: "<h3>Vos abonnements ont bien été modifiés !</h3><p>Vos préférences de contact par e-mail ont été mises à jour.</p>",
        formDescription: "Vos préférences de communication et de contact par e-mail sont importantes pour nous. Nous souhaitons vous envoyer des informations qui vous permettront, à vous et à votre entreprise, de mettre en place un meilleur mode de travail.  Mettez à jour vos préférences de contact par e-mail afin de vous assurer de recevoir les communications Citrix susceptibles de vous intéresser.",
        labelOne: "Parlez-nous de vous",
        labelTwo: "De quels sujets aimeriez-vous entendre parler ?",
        labelThree: "Comment aimeriez-vous être contacté(e) ?",
    },
    optOut: {
        formTitle: "Désabonnement",
        thankyou: "Vos préférences de contact par e-mail ont été mises à jour. S’il s’agit d’une erreur ou si vous souhaitez vérifier vos préférences, vous pouvez consulter à tout moment notre centre de gestion des préférences.",
        formDescription: "Nous sommes désolés de vous voir partir. N’hésitez pas à revenir nous voir bientôt sur Citrix.fr. Nous proposons sans cesse de nouvelles fonctions et fonctionnalités pour adapter les produits Citrix à vos besoins.",

    },
    validation: validationMessages
}